<div id="vision" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title mb-4">Vision and Mission</h2>
      </div>

      <div class="col-12 mb-4 text-center">
        <img
          src="/assets/img/library/Vission_mission.png"
          alt="Library Vision"
          class="img-fluid"
        />
      </div>

      <div class="col-12">
        <h5 class="fw-bold" style="color: var(--primary);">Our Vision</h5>
        <p class="inner-lead">
          The main thrust of the library is to improve the quality of services and facilities,
          achieve high degree of users’ satisfaction and endeavor to facilitate right information to right
          users at the right time.
        </p>

        <h5 class="fw-bold mt-4" style="color: var(--primary);">Our Mission</h5>
        <p class="inner-lead">
          The mission of the college library is to support and enhance the academic,
          professional, Cultural and lifelong learning needs of the library users.
          The Library comprises of more than 22888 books, 7 Magazines,
          10 offline Journals and 10 Hindi & English Newspapers.
        </p>
      </div>
    </div>
  </div>
</div>
